import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakpoints } from '~/src/features/_layout/Header/types';

export const CityPhone = styled.a`
    ${FONTS.MediumXXS};
    color: ${COLORS.TextHint};
    text-decoration: none;

    &:hover {
        color: ${COLORS.TextPrimary};
    }


    @media (max-width: ${wideBreakpoints.laptop}) {
        align-self: center;
        color: ${COLORS.TextPrimary};
    
        line-height: 27px;
        white-space: nowrap;
        background-color: ${COLORS.BgMain};
        border-radius: 14px;
        transition: 0.3s color ease;
        margin-right: 24px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-right: 46px;
    }    
    

    @media (max-width: ${breakpoints.mMobile}) {
        margin-right: 0;
    }
`;
